import React from "react";
import { Quote } from "lucide-react";
import SectionHeading from "./SectionHeading";

const TESTIMONIALS = [
  {
    quote: "This hotel went from anonymous to personalized. Guests are coming back because they feel known.",
    name: "Daniel Hahn",
    role: "General Manager",
    company: "Aurelia Singapore · Luxury Hotel",
    accent: true,
  },
  {
    quote: "I expected foot traffic. What I got was actual customer intelligence.",
    name: "Mia Tanaka",
    role: "Marketing Director",
    company: "OBSCURA Tokyo · Retail Flagship",
  },
  {
    quote: "We spotted 12 influencers in the first month. That alone justified the investment.",
    name: "Cole Reyes",
    role: "Senior Event Marketer",
    company: "VANTAGE Tech · Brand Activations",
  },
  {
    quote: "Repeat visits doubled. We're not just a beautiful space anymore — we're an experience.",
    name: "Amelia Cortez",
    role: "Owner",
    company: "Margot · Premium Restaurant",
  },
];

export default function TestimonialWall() {
  return (
    <section
      data-testid="testimonial-wall"
      className="relative py-24 lg:py-32 border-b border-stori-border"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionHeading
          eyebrow="OPERATORS ON THE RECORD"
          title="What teams say after 90 days."
        />

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className={`relative p-7 rounded-2xl border flex flex-col justify-between min-h-[280px] ${
                t.accent
                  ? "border-stori-cyan/40 bg-gradient-to-br from-stori-surface1 to-stori-surface2"
                  : "border-stori-border bg-stori-surface1"
              } hover:border-stori-cyan/50 transition-colors`}
            >
              <Quote className={`w-6 h-6 ${t.accent ? "text-stori-cyan" : "text-stori-borderStrong"}`} />
              <blockquote className="mt-6 text-white text-base lg:text-lg leading-snug font-medium">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6 pt-4 border-t border-stori-border">
                <div className="text-white text-sm font-semibold">{t.name}</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-stori-muted mt-1">
                  {t.role} · {t.company}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
